export { cn } from "@dolfin/lib";

/** Unsaved-change ring for settings controls. Amber is a core palette colour, so it never depends on theme tokens. */
export const dirtyRing = "border-amber-500 ring-2 ring-amber-500/50";
